import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export var defaultConfig = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'favorites',
  pathApi: '/v1/create-folder/',
  requestType: 'json'
};
export function createCreateFolderModel(parameters) {
  return _objectSpread(_objectSpread({}, defaultConfig), {}, {
    parameters: parameters
  });
}
export function fetchCreateFolder(_x) {
  return _fetchCreateFolder.apply(this, arguments);
}
function _fetchCreateFolder() {
  _fetchCreateFolder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var httpApi, config, mappers, parameters, _yield$httpApi$fetch, statusCode, response, headers;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          httpApi = _ref.httpApi, config = _ref.config, mappers = _ref.mappers, parameters = _ref.parameters;
          _context.next = 3;
          return httpApi.fetch(createCreateFolderModel(parameters), config);
        case 3:
          _yield$httpApi$fetch = _context.sent;
          statusCode = _yield$httpApi$fetch.statusCode;
          response = _yield$httpApi$fetch.response;
          headers = _yield$httpApi$fetch.headers;
          if (!(mappers && statusCode in mappers)) {
            _context.next = 12;
            break;
          }
          if (!(statusCode === 200)) {
            _context.next = 10;
            break;
          }
          return _context.abrupt("return", mappers[200](response));
        case 10:
          if (!(statusCode === 400)) {
            _context.next = 12;
            break;
          }
          return _context.abrupt("return", mappers[400](response));
        case 12:
          return _context.abrupt("return", {
            statusCode: statusCode,
            response: response,
            headers: headers
          });
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchCreateFolder.apply(this, arguments);
}